module.exports = __webpack_public_path__ + "img/26-wagoneer-l.38c55bf6.jpg";